'use client'

import { useQuery } from '@tanstack/react-query'

import { fetchEconomicCalendarHistory } from '@/service/economic-calendar.api'
import { snapshotAndUpdateQueryOptions } from '@/service/snapshot-query-options'
import type { EconomicCalendarHistoryRequest } from '@/types/generated/public_api'

export const economicCalendarKeys = {
  all: ['economic-calendar'] as const,
  history: (params: EconomicCalendarHistoryRequest) =>
    [...economicCalendarKeys.all, 'history', params] as const,
}

export function useEconomicCalendarHistory(
  params: EconomicCalendarHistoryRequest = {},
  enabled = true,
  streamUpdates = false
) {
  return useQuery({
    queryKey: economicCalendarKeys.history(params),
    queryFn: () => fetchEconomicCalendarHistory(params),
    enabled,
    ...(streamUpdates ? snapshotAndUpdateQueryOptions : { staleTime: 5 * 60 * 1000 }),
  })
}
